function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.699 258.204c-33.31-93.165 23.674-220.459 120.7-252.01 16.992-5.71 55.931-10.698 73.881.522 26.581 16.614 10.15 71.602 33.863 132.156 25.956 66.128 99.641 74.179 90.806 136.895-6.51 46.211-40.29 66.347-72.012 77.008-95.97 32.36-215.494-5.797-247.238-94.571z",
  fill: "#F0CBD6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M262.439 41.8c20.797-10.005 42.263 6.672 44.83 26.493 2.567 19.821-12.571 35.564-32.073 35.601-19.502.037-33.554-52.088-12.757-62.093z",
  fill: "#E48358"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M331.21 78.521l-9.613-2.136m9.143-15.936l-9.479 2.168m1.315-17.498l-7.555 5.818m10.191 42.104l-8.128-4.933",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgImgBgSlideshowFeatures3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 365,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMzIiBoZWlnaHQ9IjM2NSIgdmlld0JveD0iMCAwIDMzMyAzNjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjY5ODg4IDI1OC4yMDRDLTIzLjYxMDEgMTY1LjAzOSAzMy4zNzM0IDM3Ljc0NTQgMTMwLjM5OSA2LjE5MzlDMTQ3LjM5MSAwLjQ4NDMyOSAxODYuMzMgLTQuNTA0MDEgMjA0LjI4IDYuNzE2MTFDMjMwLjg2MSAyMy4zMzAxIDIxNC40MyA3OC4zMTc3IDIzOC4xNDMgMTM4Ljg3MkMyNjQuMDk5IDIwNSAzMzcuNzg0IDIxMy4wNTEgMzI4Ljk0OSAyNzUuNzY3QzMyMi40MzkgMzIxLjk3OCAyODguNjU5IDM0Mi4xMTQgMjU2LjkzNyAzNTIuNzc1QzE2MC45NjcgMzg1LjEzNSA0MS40NDI2IDM0Ni45NzggOS42OTg4OCAyNTguMjA0WiIgZmlsbD0iI0YwQ0JENiIvPgo8cGF0aCBkPSJNMjYyLjQzOSA0MS44MDA3QzI4My4yMzYgMzEuNzk1IDMwNC43MDIgNDguNDcxNiAzMDcuMjY5IDY4LjI5MjhDMzA5LjgzNiA4OC4xMTQgMjk0LjY5OCAxMDMuODU3IDI3NS4xOTYgMTAzLjg5NEMyNTUuNjk0IDEwMy45MzEgMjQxLjY0MiA1MS44MDY0IDI2Mi40MzkgNDEuODAwN1oiIGZpbGw9IiNFNDgzNTgiLz4KPHBhdGggZD0iTTMzMS4yMSA3OC41MjExTDMyMS41OTcgNzYuMzg0OU0zMzAuNzQgNjAuNDQ5TDMyMS4yNjEgNjIuNjE3Mk0zMjIuNTc2IDQ1LjExODlMMzE1LjAyMSA1MC45MzY2TTMyNS4yMTIgOTMuMDQwOUwzMTcuMDg0IDg4LjEwNzgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgImgBgSlideshowFeatures3 as ReactComponent };